
import SurveyResponsePage from "@/pages/shared/surveys/SurveyResponsePage";

export default function UserSurveyResponsePage() {
  return <SurveyResponsePage viewType="user" />;
}
